import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { CompanyCommercial } from 'modules/domain/company/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ResponsiveModal } from 'views/components/ResponsiveModal/ResponsiveModal'
import { SharedModalContent, SharedModalInputs } from 'views/components/SharedModal'
import { CommonFields } from '../CommonFields'

type Props = {
  onClose: () => void
  parentId?: string
  onSuccess: () => void
}
export const USAddCompanyModal: FC<Props> = ({ onClose, parentId, onSuccess }) => {
  const { t } = useTranslation('company')
  const { formProgress, formHandler } = useAFormHandler()

  const formik = useFormik({
    initialValues: {
      name: null,
      is_significant: false,
      main_address: null,
      responsible_coordinator: null,
      inn: null,
      commercial: CompanyCommercial.unknown,
      responsible_seller: null,
      responsible_customer: null,
      merged_responsible: null,
      parent: parentId,
    },

    onSubmit: formHandler(
      (val) => {
        const { merged_responsible, ...actualFormValues } = val

        if (merged_responsible) {
          actualFormValues.responsible_seller = merged_responsible
          actualFormValues.responsible_customer = merged_responsible
        }
        return apiClient.post(endpoints.company(), actualFormValues)
      },
      {
        onSuccess: () => {
          onSuccess()
          onClose()
        },
        onError: (err) => {
          formik.setErrors(err.errors)
        },
      },
    ),
  })

  const addressHandler = (address) => {
    formik.setFieldValue('main_address', {
      geo_object: address.geoObject,
      address: address.address,
      latitude: address.coords && address.coords[0],
      longitude: address.coords && address.coords[1],
    })
  }

  return (
    <ResponsiveModal
      id="addCompany"
      onClose={onClose}
      title={t('form.add')}
      progress={formProgress}
      onConfirm={formik.submitForm}
    >
      <SharedModalContent>
        <SharedModalInputs>
          <CommonFields.NameCompany formik={formik} withSignificant />
          <CommonFields.AddressField formik={formik} handlerMap={addressHandler} required />
          <CommonFields.ResponsibleField formik={formik} required />
          <CommonFields.PersonalNumber formik={formik} />
          <CommonFields.CommercialField formik={formik} />
          <CommonFields.USCompanyResponsibleUsers formik={formik} />
        </SharedModalInputs>
      </SharedModalContent>
    </ResponsiveModal>
  )
}
